<template>
  <div
    class="main"
  >
    <loading
      :show="isLoading"
      label="加载中"
    />
    <div class="main-hd">
      <p class="tit">
        {{ getIntroTypeName(typeID) }}
      </p>
      <div class="crumb">
        <span>您的位置：</span>
        <router-link to="/">
          官网首页
        </router-link>
        <span> &gt; </span>
        <span>{{ getIntroTypeName(typeID) }}</span>
      </div>
    </div>
    <div class="main-bd">
      <div class="c1">
        <a
          :class="typeID===1?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoTo(1)"
        >{{ getIntroTypeName(1) }}</a>
        <a
          :class="typeID===2?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoTo(2)"
        >{{ getIntroTypeName(2) }}</a>
        <a
          :class="typeID===3?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoTo(3)"
        >{{ getIntroTypeName(3) }}</a>
        <a
          :class="typeID===4?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoTo(4)"
        >{{ getIntroTypeName(4) }}</a>
        <a
          :class="typeID===5?'nav current':'nav'"
          href="javascript:void(0)"
          @click="GoTo(5)"
        >{{ getIntroTypeName(5) }}</a>
      </div>
      <div class="c2">
        <ul
          class="articles"
        >
          <li
            class="item"
            v-for="(item,index) in page_arrs"
            :key="index"
          >
            <span class="tag">【{{ getIntroTypeName(item.typeID) }}】</span>
            <a
              href="javascript:void(0)"
              class="con"
              @click="GoToContent(item.id,typeID)"
            >
              {{ item.title }}
            </a>
            <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
          </li>
        </ul>
        <div class="pagination">
          <ul
            v-for="n in page_count"
            :key="n"
          >
            <li :class="n===pageIndex?'page selected':'page'">
              <a
                href="javascript:void(0)"
                :class="n===pageIndex?'current':''"
                @click="pageIndex = n"
              >{{ n }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { getIntroTypeName } from '../../utils/utils'

export default {
  components: {
    loading
  },
  created () {
    // console.log('mounted:' + this.typeID)
    // this.typeID = this.$route.query.typeID || 0
    // console.log('created begin:' + this.isLoading)
    this.getList()
    // console.log('created end:' + this.isLoading)
  },
  watch: {
    '$route' (to, from) {
    // 刷新参数放到这里里面去触发就可以刷新相同界面了
      this.typeID = parseInt(this.$route.query.typeID) || 0
      // console.log('route begin:' + this.isLoading)
      this.getList()
      // console.log('route end:' + this.isLoading)
      // console.log('route:' + this.typeID)
    }
  },
  data () {
    return {
      typeID: parseInt(this.$route.query.typeID) || 1,
      list: [],
      isLoading: true,
      pageIndex: 1,
      pageCount: 1,
      pageSize: 15
    }
  },
  computed: {
    page_arrs () {
      const { pageIndex, pageSize } = this
      return this.list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)
    },
    page_count () {
      return Math.ceil(this.list.length / this.pageSize)
    }
  },
  methods: {
    getList () {
      this.isLoading = true
      this.$api.getIntroList(this.typeID).then(res => {
        this.list = res.data.list
      })
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    },
    GoTo (typeID) {
      this.$router.push({
        path: '/intro/list',
        query: {
          typeID: typeID
        }
      })
    },
    GoToContent (id, typeID) {
      this.$router.push({
        path: '/intro/view',
        query: {
          id: id,
          tid: typeID
        }
      })
    },
    getIntroTypeName
  }
}
</script>



// WEBPACK FOOTER //
// src/components/intro/main.vue